export var ComparisonOperator;
(function (ComparisonOperator) {
    ComparisonOperator["LESS_THAN_EQUAL"] = "LESS_THAN_EQUAL";
    ComparisonOperator["LESS_THAN"] = "LESS_THAN";
    ComparisonOperator["GREATER_THAN_EQUAL"] = "GREATER_THAN_EQUAL";
    ComparisonOperator["GREATER_THAN"] = "GREATER_THAN";
})(ComparisonOperator || (ComparisonOperator = {}));
export var AndOrOperator;
(function (AndOrOperator) {
    AndOrOperator["AND"] = "AND";
    AndOrOperator["OR"] = "OR";
})(AndOrOperator || (AndOrOperator = {}));
export var CriteriaGroupType;
(function (CriteriaGroupType) {
    CriteriaGroupType["ALL_OF"] = "Condition-AND";
    CriteriaGroupType["ANY_OF"] = "Condition-OR";
    CriteriaGroupType["NONE_OF"] = "Condition-NOR";
})(CriteriaGroupType || (CriteriaGroupType = {}));
export var CriteriaTerminalType;
(function (CriteriaTerminalType) {
    CriteriaTerminalType["PASS"] = "Pass";
    CriteriaTerminalType["AGE"] = "Age";
    CriteriaTerminalType["AMOUNT"] = "Amount";
    CriteriaTerminalType["FEE_FINE_OWNER"] = "FeeFineOwner";
    CriteriaTerminalType["FEE_FINE_TYPE"] = "FeeType";
    CriteriaTerminalType["LOCATION"] = "Location";
    CriteriaTerminalType["SERVICE_POINT"] = "ServicePoint";
    CriteriaTerminalType["PATRON_GROUP"] = "PatronGroup";
})(CriteriaTerminalType || (CriteriaTerminalType = {}));
export var CriteriaAggregateType;
(function (CriteriaAggregateType) {
    CriteriaAggregateType["PASS"] = "Pass";
    CriteriaAggregateType["NUM_ROWS"] = "NumRows";
    CriteriaAggregateType["TOTAL_AMOUNT"] = "TotalAmount";
})(CriteriaAggregateType || (CriteriaAggregateType = {}));
export var CriteriaTokenType;
(function (CriteriaTokenType) {
    CriteriaTokenType["NUM_ROWS"] = "NUM_ROWS";
    CriteriaTokenType["TOTAL_AMOUNT"] = "TOTAL_AMOUNT";
})(CriteriaTokenType || (CriteriaTokenType = {}));
